<template>
  <div class="container-fluid">
    <div class="content">
      <form @submit.prevent>
        <div class="row">
          <div class="col">
            <BaseInput
              label="First Name"
              v-model="user.first_name"
              :error-message="errorMessages['first_name']"
            />
          </div>
          <div class="col">
            <BaseInput
              label="Last Name"
              v-model="user.last_name"
              :error-message="errorMessages['first_name']"
            />
          </div>
        </div>
        <BaseInput label="Email" v-model="user.email" :error-message="errorMessages['email']"/>
        <BaseInput
          type="password"
          label="Password"
          v-model="user.password"
          :error-message="errorMessages['password']"
        />
        <BaseInput
          label="Confirm Password"
          v-model="user.password_confirmation"
          :error-message="errorMessages['password_confirmation']"
        />
        <div class="text-center">
          <BaseButton v-if="!edit" style-type="action" @click.native="createUser()">Create</BaseButton>
          <BaseButton v-else style-type="action" @click.native="updateUser()">Update</BaseButton>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import Users from '@/resources/Users.js'

export default {
  data () {
    return {
      user: {
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        password_confirmation: ''
      },
      errorMessages: {},
      edit: false
    }
  },
  mounted () {
    this.edit = this.$route.params.id
    if (this.edit) {
      this.getUser(this.edit)
    }
  },
  methods: {
    getUser (uuid) {
      Users.show(uuid)
        .then((response) => {
          if (!response.error) {
            this.user = response
          }
        })
    },
    createUser () {
      this.errorMessages = {}
      Users.create(this.user)
        .then((response) => {
          if (response.error && response.status === 422) {
            this.errorMessages = response.body
          } else if (!response.error) {
            this.$toast('User successfully created.')
            this.$router.push('/users')
          }
        })
    },
    updateUser () {
      this.errorMessages = {}
      Users.update(this.user.uuid, this.user)
        .then((response) => {
          if (response.error && response.status === 422) {
            this.errorMessages = response.body
          } else if (!response.error) {
            this.$toast('User successfully updated.')
            this.$router.push('/users')
          }
        })
    }
  },
  computed: {},
  components: {}
}
</script>
<style lang="scss" scoped>
</style>
